import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ConfirmEmailChangePage } from '@/pages/confirm-email-change/confirm-email-change-page';

const ConfirmEmailChangeSearchSchema = z.object({
  token: z.string().min(8),
});

export const Route = createFileRoute('/confirm-email-change')({
  component: ConfirmEmailChangePage,
  validateSearch: ConfirmEmailChangeSearchSchema,
});
